// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoV1CardDetailsVirtualDebitCard {
    'activationCode': string;
    'accountNumber': string;
    'cardNumber': string;
    'cvc': string;
    'cardBalance': number | null;
    'benefitRemaining'?: number | null;
    'benefitUsed'?: number | null;
    'importantSafetyInformation': string;
    'cardImage': string;
    'usageText': string;
    'termsAndConditions': string;
    'supportPhoneNumber': string;
    'patientInstructions': string;
    'processorInstructions': string;
    'expirationDate': Moment;
    'enrollmentDate'?: Moment | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoV1CardDetailsVirtualDebitCard>> = [
        {
            "name":     "activationCode",
            "baseName": "activationCode",
            "type":     "string"
        },
        {
            "name":     "accountNumber",
            "baseName": "accountNumber",
            "type":     "string"
        },
        {
            "name":     "cardNumber",
            "baseName": "cardNumber",
            "type":     "string"
        },
        {
            "name":     "cvc",
            "baseName": "cvc",
            "type":     "string"
        },
        {
            "name":     "cardBalance",
            "baseName": "cardBalance",
            "type":     "number"
        },
        {
            "name":     "benefitRemaining",
            "baseName": "benefitRemaining",
            "type":     "number"
        },
        {
            "name":     "benefitUsed",
            "baseName": "benefitUsed",
            "type":     "number"
        },
        {
            "name":     "importantSafetyInformation",
            "baseName": "importantSafetyInformation",
            "type":     "string"
        },
        {
            "name":     "cardImage",
            "baseName": "cardImage",
            "type":     "string"
        },
        {
            "name":     "usageText",
            "baseName": "usageText",
            "type":     "string"
        },
        {
            "name":     "termsAndConditions",
            "baseName": "termsAndConditions",
            "type":     "string"
        },
        {
            "name":     "supportPhoneNumber",
            "baseName": "supportPhoneNumber",
            "type":     "string"
        },
        {
            "name":     "patientInstructions",
            "baseName": "patientInstructions",
            "type":     "string"
        },
        {
            "name":     "processorInstructions",
            "baseName": "processorInstructions",
            "type":     "string"
        },
        {
            "name":     "expirationDate",
            "baseName": "expirationDate",
            "type":     "Date"
        },
        {
            "name":     "enrollmentDate",
            "baseName": "enrollmentDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return MangoV1CardDetailsVirtualDebitCard.attributeTypeMap;
    }
}
